<script lang="ts">
    interface Props {
        eyebrow?: string;
        title: string;
        description?: string;
        align?: 'center' | 'left';
    }
    let { eyebrow, title, description, align = 'center' }: Props = $props();
</script>

<div class={align === 'center' ? 'mb-12 flex flex-col items-center text-center' : 'mb-12 flex flex-col items-start'}>
    {#if eyebrow}
        <span
            class="text-blue-soft mb-4 font-display text-[11px] font-medium uppercase tracking-[0.2em]"
        >
            {eyebrow}
        </span>
    {/if}
    <h2
        class="text-gradient-enterprise font-display text-4xl font-medium leading-[1.1] tracking-tight lg:text-5xl"
        class:max-w-3xl={align === 'center'}
    >
        {title}
    </h2>
    {#if description}
        <p
            class="mt-5 font-display text-lg leading-relaxed text-white/65"
            class:max-w-2xl={align === 'center'}
        >
            {description}
        </p>
    {/if}
</div>
